import HowdyBox from "js/searches/howdy_box/howdy_box";

const HowdyBoxStatic = () => {
  const handleOptionClick = (option) => {
    const searchTabs = LP.config.search_tabs || [];
    const tab = searchTabs.find(t => t.title === option.tabTitle);

    if (tab && tab.url) {
      let url = tab.url;
      if (option.key === "ai_lesson_plans") {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set("ai_tool", "lesson_plan_generator");
        url = urlObj.toString();
      }
      window.location.href = url;
    }
  };

  return (
    <HowdyBox
      howdyBoxClassName="lg:gap-10"
      onClick={handleOptionClick}
    />
  );
};

export default HowdyBoxStatic;
